const HIDE_PARTIAL_DATASET_TIMEOUT = 60 * 1000; // 60secs

export default {
  data() {
    return {
      showPartialDataSetMessage: false
    };
  },

  created () {
    this.hidePartialDatasetNotificationTimeout = null;
  },

  methods: {
    showPartialDatasetNotification() {
      this.showPartialDataSetMessage = true;

      this.hideNotificationAfterTime(HIDE_PARTIAL_DATASET_TIMEOUT);
    },

    hideNotificationAfterTime(time) {
      this.clearNotificationTimeout();

      this.hidePartialDatasetNotificationTimeout = setTimeout(() => {
        this.showPartialDataSetMessage = false;
      }, time);
    },
    
    hidePartialDatasetNotification() {
      this.clearNotificationTimeout();
      
      this.showPartialDataSetMessage = false;
    },

    clearNotificationTimeout() {
      if (this.hidePartialDatasetNotificationTimeout) {
        clearTimeout(this.hidePartialDatasetNotificationTimeout);
        this.hidePartialDatasetNotificationTimeout = null;
      }
    }
  },
};